module.exports = __webpack_public_path__ + "img/md.2094cef4.jpg";